import Header from "./Header";
import Sidebar from "./sidebar/Sidebar";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";
import { useState } from "react";

function AdminLayout() {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const handleMenuClick = () => {
    if (window.innerWidth >= 1024) {
      setSidebarCollapsed((prev) => !prev);
    } else {
      setMobileSidebarOpen(true);
    }
  };

  return (
    <div className="flex h-screen bg-[#f1f5f9] overflow-hidden">

      {mobileSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-20 lg:hidden"
          onClick={() => setMobileSidebarOpen(false)}
        />
      )}

      <aside
        className={[
          "fixed lg:relative inset-y-0 left-0 z-30 flex-shrink-0",
          "transition-all duration-300 ease-in-out",
          mobileSidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0",
          "w-64",
          sidebarCollapsed ? "lg:w-[72px]" : "lg:w-64",
        ].join(" ")}
      >
        <Sidebar
          onClose={() => setMobileSidebarOpen(false)}
          collapsed={sidebarCollapsed}
          onToggle={() => setSidebarCollapsed((p) => !p)}
        />
      </aside>

      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        <Header onMenuClick={handleMenuClick} />
        <main className="flex-1 overflow-y-auto ">
          <Outlet />
        </main>
        <Footer />
      </div>

    </div>
  );
}

export default AdminLayout;